import {Button, Modal} from 'react-bootstrap'
import {parseId, parsePrice} from '../../helpers'
import {useMutation} from '@apollo/client'
import {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {Spinner} from '../Spinner'
import {EDIT_ONE_PRICE} from '../../graphql/mutations/clientMutations'
import {IResEditPrice} from '../../graphql/types/clientsTypes'
import {InputCurrency} from '../InputCurrency'

interface IInfoPriceDelete {
  price: string
  idPrice: string
  idProduct: string
  productName: string
  idClient: string
}

interface IModalProps {
  isOpen: boolean
  onClose: () => void
  onOpenPrices: () => void
  refetch: () => void
  info: IInfoPriceDelete
}

export const ModalEditPrice: React.FC<IModalProps> = ({
  isOpen,
  onClose,
  info,
  onOpenPrices,
  refetch,
}) => {
  const [gqlEdit, {data, loading, error}] = useMutation<IResEditPrice>(EDIT_ONE_PRICE)

  const [price, setPrice] = useState('')

  useEffect(() => {
    if (error) toast.error(`Error: ${error.message}`)
  }, [error])

  useEffect(() => {
    console.log('first')
    setPrice(info.price)
  }, [info.price])

  useEffect(() => {
    if (!data) return
    if (data.productPriceClientUpdate.success) {
      refetch()
      onClose()
      toast.success('Precio cambiado correctamente')
    } else if (data.productPriceClientUpdate.errors) {
      toast.error(`Error: ${data.productPriceClientUpdate.errors.message}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    console.log('price', price)
    if (!price || isNaN(Number(price))) return

    gqlEdit({
      variables: {
        input: {
          id: parseId(info.idPrice),
          productId: parseId(info.idProduct),
          clientId: parseId(info.idClient),
          price,
        },
      },
    })
  }

  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Editar precio</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h2 className='fs-2'>
          Usted cambiará el precio <span className='text-info'>{parsePrice(info.price)}</span> del
          producto <span className='text-danger'>{info.productName}</span>
        </h2>

        <form onSubmit={handleSubmit} id='formId'>
          <div>
            <label className='fw-bold' htmlFor='prices'>
              Ingrese el precio
            </label>
            <InputCurrency
              id='price'
              placeholder='Ingrese precio'
              name='price'
              value={price}
              onValueChange={(e) => setPrice(e || '')}
            />
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant='light'
          onClick={() => {
            onClose()
            onOpenPrices()
          }}
        >
          Cancelar
        </Button>
        <Button variant='dark' disabled={loading} form='formId' type='submit'>
          {loading && <Spinner color='light' size={12} />}
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
